import Input, { InputVariant } from '@ben/orion/input';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';

const InternalNotes = () => {
  const { control } = useFormContext<IModularBenefitDetail>();

  return (
    <Wrapper>
      <TitleWrapper>
        <Typography variant={TypographyVariant.h2}>Internal Notes</Typography>
      </TitleWrapper>
      <InternalNotesContainer>
        <Controller
          name="internalNotes"
          control={control}
          render={({ field }) => {
            const { value, ...rest } = field;
            return (
              <Input
                {...rest}
                name="Notes"
                hintText="Internal notes for ben staff only. Not visible to employees or employers."
                showLabel={true}
                variant={InputVariant.TextArea}
                value={value ?? ''}
                width="100%"
                maxLength={500}
                height="150px"
              />
            );
          }}
        />
      </InternalNotesContainer>
    </Wrapper>
  );
};

export default memo(InternalNotes);

const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    border: 1px solid ${theme.palette.neutral[60]};
    padding: ${theme.spacing(3)};
    border-radius: 10px;
  `}
`;

const InternalNotesContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background: ${theme.palette.primary.bg};
    padding: ${theme.spacing(3)};
    border-radius: 10px;
    width: 100%;
  `}
`;
